<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="{{!isRetracted ?'agpr-contentEditable':'agpr-disableContentEditable'}} agpr-contextMenu-parent" [ngStyle]="boxStyle" >
    <ul
        role="group"
        [attr.aria-label]="ariaLabel + ' Text Block'"
        [attr.aria-describedby]="errorsId + ' ' + (id + '_errors')"
    >
        <ul
            class="agpr-contextMenu top left"
            [ngClass]="{'agpr-contentEditable-iconBlock--mod':editable}"
            *ngIf="showMoveButtons && !isRetracted && !editable"
            role="menu"
            aria-label="Move Block"
        >
            <li role="menuitem" *ngIf="!moveUpDisabled">
                <agpr-button
                    icon="fa-regular fa-arrow-up"
                    class="agpr-contentEditable-moveUp"
                    (click)="onMoveUp()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.moveUp'"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </li>
            <li role="menuitem" *ngIf="!moveDownDisabled">
                <agpr-button
                    icon="fa-regular fa-arrow-down"
                    class="agpr-contentEditable-moveDown"
                    (click)="onMoveDown()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.moveDown'"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </li>
        </ul>
        <ul
            *ngIf="!isRetracted && !editable"
            class="agpr-contextMenu top right"
            [ngClass]="{'agpr-contentEditable-iconBlock--mod':editable}"
            role="menu"
            aria-label="Edit Block"
        >
            <li role="menuitem" *ngIf="showDelete">
                <agpr-button
                    class="agpr-contentEditable-delete"
                    icon="fa-regular fa-duotone fa-trash-can"
                    (click)="onDelete($event)"
                    [tooltip]="'PageBuilder.briefings.blockIcon.delete'"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    class="agpr-contentEditable-edit"
                    icon="fa-regular fa-duotone fa-pen"
                    (click)="onEdit($event)"
                    [tooltip]="'PageBuilder.briefings.blockIcon.edit'"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </li>
        </ul>
    </ul>



    <div
        class="agpr-contentEditable-box agpr-contentEditable-editorBox ql-editor ql-snow"
        [ngClass]="{
            'agpr-contentEditable-boxPlaceholder': !content,
            'agpr-contentEditable-boxTransparentStyle': content
        }"
        *ngIf="!editable"
        [ngStyle]="boxStyle"
        (click)="onEdit($event)"
    >
        <span *ngIf="!content">
            <span class="agpr-contentEditable-placeholderIcon" [ngClass]="placeholderIcon"></span><span class="agpr-contentEditable-placeholderText">{{placeholder}}</span>
        </span>
        <div *ngIf="content" [innerHTML]="content"></div>
    </div>
    <p-editor #editor
        [(ngModel)]="content"
        *ngIf="editable"
        [style]="boxStyle"
        styleClass="agpr-contentEditable-editor agpr-contentEditable-editorBox"
        (onSelectionChange)="onChange($event)"
        (onTextChange)="onTextChange($event)"
        (onInit)="onInit($event)"
        [formats]="['bold','italic','underline','link','strike','script','list']"
        (keydown.escape)="escapeTextEditor()"
    >
        <p-header>
            <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-script sub" value="sub" aria-label="Sub Script">
                    <span class="fa-regular fa-duotone fa-subscript" aria-hidden="true"></span>
                </button>
                <button class="ql-script super" value="super" aria-label="Super Script">
                    <span class="fa-regular fa-duotone fa-superscript" aria-hidden="true"></span>
                </button>
            </span>
            <span class="ql-formats">
                <button class="ql-list ol" value="ordered" aria-label="Ordered List">
                    <span class="fa-regular fa-duotone fa-list-ol" aria-hidden="true"></span>
                </button>
                <button class="ql-list ul" value="bullet" aria-label="Unordered List">
                    <span class="fa-regular fa-duotone fa-list-ul" aria-hidden="true"></span>
                </button>
            </span>
            <span class="ql-formats">
                <button class="ql-link" aria-label="Insert Link">
                    <span class="fa-regular fa-duotone fa-link" aria-hidden="true"></span>
                </button>
            </span>
        </p-header>
    </p-editor>
    <div
        *ngIf="(htmlContentLimitExceedMessage && (content && content.length > maxHtmlContentLength))"
        class='agpr-contentEditable-error'
        [id]="id + '_errors'"
    >
        {{ htmlContentLimitExceedMessage }}
    </div>
</div>
